import React, {useContext} from 'react';
import {useForm} from 'react-hook-form';
import {Grid, Button, FormHelperText} from '@material-ui/core';
import {KeyboardDatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import * as Yup from 'yup';
import DateFnsUtils from '@date-io/date-fns';
import {Controller} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers/yup';
import {ThemeContext} from '../../themes/ThemeProvider';


const EditEndDate = ({rowData}) => {
  const initialValues = {
    endDate: rowData.endDate ? rowData.endDate : null,
    effectiveDate: rowData.effectiveDate ? rowData.effectiveDate : null,
  };
  const validationSchema = Yup.object().shape({
    effectiveDate: Yup.date().nullable(),
    endDate: Yup.date()
      .nullable()
      .min(Yup.ref('effectiveDate'), 'End date should not be below the Effective Date')
      .typeError('Invalid date format'),
  });
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const {handleSubmit, control, errors, reset} = useForm({
    mode: 'all',
    defaultValues: initialValues,
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = (values) => {};
  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="col">
          <div className="form-row">
            <div className="col-sm-6 col-md-6 form-group">
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container>
                  <Controller
                    render={({value, onChange}) => (
                      <KeyboardDatePicker
                        className={` ${classes.labelName} ${classes.datePicker}`}
                        format="MM/dd/yyyy"
                        placeholder="MM/DD/YYYY"
                        fullWidth
                        value={value}
                        disabled
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputVariant="outlined"
                        label="Effective Date"
                        onChange={onChange}
                        autoOk
                        margin="dense"
                      />
                    )}
                    control={control}
                    name="effectiveDate"
                  />
                </Grid>
              </MuiPickersUtilsProvider>
            </div>
            <div className="col-sm-6 col-md-6 form-group">
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container>
                  <Controller
                    render={({value, onChange}) => (
                      <KeyboardDatePicker
                        className={` ${classes.labelName} ${classes.datePicker}`}
                        format="MM/dd/yyyy"
                        placeholder="MM/DD/YYYY"
                        fullWidth
                        value={value}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputVariant="outlined"
                        label="End Date"
                        onChange={onChange}
                        autoOk
                        margin="dense"
                      />
                    )}
                    control={control}
                    name="endDate"
                  />
                </Grid>
              </MuiPickersUtilsProvider>
              <FormHelperText style={{color: 'red'}} margin="dense" variant="outlined">
                {errors.endDate?.message ? errors.endDate.message : ''}
              </FormHelperText>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-center mt-2">
          <Button
            type="reset"
            onClick={() => reset(initialValues)}
            variant="contained"
            className={`mx-1 ${classes.buttonRoot}`}
          >
              Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            className={`themeing-buttons mx-1 ${classes.buttonRoot}`}
          >
              save
          </Button>
        </div>

      </form>
    </div>
  );
};

export default EditEndDate;
